import { render, staticRenderFns } from "./OverviewLabour.vue?vue&type=template&id=81d5e108&scoped=true"
import script from "./OverviewLabour.vue?vue&type=script&lang=js"
export * from "./OverviewLabour.vue?vue&type=script&lang=js"
import style0 from "./OverviewLabour.vue?vue&type=style&index=0&id=81d5e108&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d5e108",
  null
  
)

export default component.exports